import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'

export interface FeedPurchaseFileSource {
  src: string
  name: string
}

interface FeedPurchasePreviewModalProps {
  fileSource: FeedPurchaseFileSource | null
  handleClose: () => void
  isBusy: boolean
}

const FeedPurchasePreviewModal: React.FC<FeedPurchasePreviewModalProps> = ({ fileSource, handleClose, isBusy }) => {
  const { t } = useTranslation()
  const refIframe = useRef<HTMLIFrameElement>(null)

  return (
    <Dialog
      open={Boolean(fileSource?.src)}
      heightContent='90%'
      heightDialog='80%'
      handleClose={handleClose}
      textContent={
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          {fileSource?.src && (
            <>
              <iframe
                ref={refIframe}
                src={fileSource.src}
                width='100%'
                height='90%'
                style={{ minHeight: '90%' }}
              />
            </>
          )}
        </div>
      }
      textHeader={t('Preview')}
      textClose={t('Close')}
      type='preview'
      isLoading={isBusy}
    />
  )
}

export default FeedPurchasePreviewModal
